<template lang="pug">
BaseSimpleView(:title='title' :icon='icon')
    template(v-slot:actions)
        slot(name='actions')

    div(style='height: calc(100vh - 90px)')
        splitpanes.tacteris-theme(horizontal)
            pane
                slot(name='default')
            pane.bottom.map(v-if='bottomPaneOpen')
                slot(name='bottom')
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import BaseSimpleView from '@/common/BaseSimpleView.vue';

export default defineComponent({
    name: 'BaseSplitHorizontalView',
    components: {
        BaseSimpleView,
        Splitpanes,
        Pane,
    },
    props: {
        icon: {
            type: String,
            default: undefined,
        },
        title: {
            type: String,
            required: true,
        },
        dataCy: {
            type: String,
            default: undefined,
        },
        bottomPaneOpen: {
            type: Boolean,
            default: true,
        },
    },
});
</script>

<style lang="scss">
@use './CommonSplitViews.scss';

.map {
    min-height: 200px;
}
</style>
